"use client";
import React, { useRef, useState } from "react";
import Image from "next/image";

export default function HeaderSection() {
	const [menuActive, setMenuActive] = useState(false);
	const offcanvasMenuRef = useRef(null);
	const overlayRef = useRef(null);

	const handleMenuBarClick = () => {
		setMenuActive(true);
	};

	const handleMenuCloseClick = () => {
		setMenuActive(false);
	};

	return (
		<>
			<div>
				<div
					ref={offcanvasMenuRef}
					className={`offcanvas-menu fixed -left-full top-0 z-50 h-screen w-full max-w-[340px] bg-white transition-all duration-500 ${
						menuActive ? "active" : ""
					}`}
					id="offcanvas-menu"
				>
					<button
						title="Close Menu"
						type="button"
						className="bg-primary-600 top-7.5 absolute right-5 rounded-lg px-2.5 py-2 text-end text-2xl leading-none text-white"
						id="menu-close"
						onClick={handleMenuCloseClick}
					>
						<svg
							xmlns="http://www.w3.org/2000/svg"
							width={24}
							height={24}
							viewBox="0 0 24 24"
							fill="none"
							stroke="#ffffff"
							strokeWidth={2}
							strokeLinecap="round"
							strokeLinejoin="round"
							className="lucide lucide-x"
						>
							<path d="M18 6 6 18" />
							<path d="m6 6 12 12" />
						</svg>
					</button>
					<div className="mt-32">
						<ul>
							<li>
								<a
									className="text-primary-600 border-b-primary-600 block border-b px-5 py-3 font-semibold capitalize transition-all duration-300 hover:pl-8"
									href="#result"
								>
									Our Results
								</a>
							</li>
							<li>
								<a
									className="text-primary-600 border-b-primary-600 block border-b px-5 py-3 font-semibold capitalize transition-all duration-300 hover:pl-8"
									href="#offerings"
								>
									Offerings
								</a>
							</li>
							<li>
								<a
									className="text-primary-600 border-b-primary-600 block border-b px-5 py-3 font-semibold capitalize transition-all duration-300 hover:pl-8"
									href="#why-us"
								>
									Why Us
								</a>
							</li>
							<li>
								<a
									className="text-primary-600 border-b-primary-600 block border-b px-5 py-3 font-semibold capitalize transition-all duration-300 hover:pl-8"
									href="#testimonials"
								>
									Testimonial
								</a>
							</li>
							<li>
								<a
									className="text-primary-600 border-b-primary-600 block border-b px-5 py-3 font-semibold capitalize transition-all duration-300 hover:pl-8"
									href="#faq"
								>
									FAQ
								</a>
							</li>
						</ul>
						<div className="mt-8 text-center">
							<a href="#bookADiscoveryCall" className="theme-btn">
								Book a Free Discovery Call
							</a>
						</div>
					</div>
				</div>
				<div
					ref={overlayRef}
					className={`overlay duration-400 invisible fixed left-0 top-0 z-40 h-full w-full bg-black/60 opacity-0 transition-all ${
						menuActive ? "active" : ""
					}`}
					id="overlay"
					onClick={handleMenuCloseClick}
				/>
			</div>

			<header className="absolute left-0 top-5 z-10 w-full md:top-12">
				<div className="container 2xl:max-w-[1330px]">
					<div className="relative flex items-center justify-between pb-4 after:absolute after:bottom-0 after:left-0 after:h-[1px] after:w-full after:bg-[radial-gradient(50%_50%_at_50%_50%,_#FFF_0%,_rgba(255,255,255,0)_100%)] sm:pb-5 md:px-8 xl:px-12">
						<a href="https://www.proptechbuzz.com" className="inline-block">
							<Image
								src="/marketing/assets/img/logo.svg"
								alt="site logo"
								className="max-w-44 sm:max-w-52 xl:max-w-44 2xl:max-w-52"
							/>
						</a>
						<nav className="hidden xl:flex">
							<ul className="flex items-center gap-4 2xl:gap-[22px]">
								<li>
									<a
										href="#result"
										className="hover:bg-primary-600 inline-block rounded-full bg-white/40 px-1.5 py-1.5 text-sm font-semibold text-[#475467] transition-all duration-300 hover:text-white"
									>
										Our Results
									</a>
								</li>
								<li>
									<a
										href="#offerings"
										className="hover:bg-primary-600 inline-block rounded-full bg-white/40 px-1.5 py-1.5 text-sm font-semibold text-[#475467] transition-all duration-300 hover:text-white"
									>
										Offerings
									</a>
								</li>
								<li>
									<a
										href="#why-us"
										className="hover:bg-primary-600 inline-block min-w-[84px] rounded-full bg-white/40 px-1.5 py-1.5 text-center text-sm font-semibold text-[#475467] transition-all duration-300 hover:text-white"
									>
										Why Us
									</a>
								</li>
								<li>
									<a
										href="#testimonials"
										className="hover:bg-primary-600 inline-block rounded-full bg-white/40 px-1.5 py-1.5 text-sm font-semibold text-[#475467] transition-all duration-300 hover:text-white"
									>
										Testimonial
									</a>
								</li>
								<li>
									<a
										href="#faq"
										className="hover:bg-primary-600 inline-block min-w-[75px] rounded-full bg-white/40 px-1.5 py-1.5 text-center text-sm font-semibold text-[#475467] transition-all duration-300 hover:text-white"
									>
										FAQ
									</a>
								</li>
							</ul>
						</nav>
						<div className="hidden items-center gap-5 xl:flex">
							<a href="#bookADiscoveryCall" className="theme-btn">
								Book a Free Discovery Call
							</a>
						</div>
						<button
							type="button"
							title="Open Menu"
							className="bg-primary-600 rounded-lg px-2.5 py-2 text-2xl leading-none text-white xl:hidden"
							id="menu-bar"
							onClick={handleMenuBarClick}
						>
							<svg
								xmlns="http://www.w3.org/2000/svg"
								width={24}
								height={24}
								viewBox="0 0 24 24"
								fill="none"
								stroke="#ffffff"
								strokeWidth={2}
								strokeLinecap="round"
								strokeLinejoin="round"
								className="lucide lucide-menu"
							>
								<line x1={4} x2={20} y1={12} y2={12} />
								<line x1={4} x2={20} y1={6} y2={6} />
								<line x1={4} x2={20} y1={18} y2={18} />
							</svg>
						</button>
					</div>
				</div>
			</header>
		</>
	);
}
